export const shoppingCartAdd = (shoppingCartString: string, productId: string, amount: Number): string => {
  const shoppingCart = JSON.parse(shoppingCartString);
  shoppingCart[productId] ? shoppingCart[productId] = shoppingCart[productId] + amount : shoppingCart[productId] = amount;
  return JSON.stringify(shoppingCart);
}